<script lang="ts">
  let {
    points,
    height = 180,
    title,
    sub,
    footLeft,
    footRight,
  }: {
    points: number[];
    height?: number;
    title?: string;
    sub?: string;
    footLeft?: string;
    footRight?: string;
  } = $props();

  const W = 540;
  const H = $derived(height);
  const max = $derived(Math.max(...points, 1));
  const pathD = $derived.by(() => {
    if (points.length === 0) return '';
    const step = W / Math.max(1, points.length - 1);
    return points
      .map((v, i) => `${i === 0 ? 'M' : 'L'} ${i * step} ${H - (v / max) * (H - 20) - 10}`)
      .join(' ');
  });
  const areaD = $derived(`${pathD} L ${W} ${H} L 0 ${H} Z`);
</script>

<div class="rounded-xl border border-[var(--color-border-3)] bg-white p-4">
  {#if title}
    <div class="flex items-center justify-between mb-3">
      <div>
        <div class="text-[13px] font-bold">{title}</div>
        {#if sub}<div class="text-[10.5px] text-[var(--color-text-muted)] mt-0.5">{sub}</div>{/if}
      </div>
    </div>
  {/if}

  <svg viewBox="0 0 {W} {H}" preserveAspectRatio="none" class="block w-full" style="height: {H}px">
    <defs>
      <linearGradient id="area-grad" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stop-color="#9B6FDE" stop-opacity="0.45" />
        <stop offset="100%" stop-color="#9B6FDE" stop-opacity="0" />
      </linearGradient>
    </defs>

    <!-- grid -->
    <g stroke="#E5E1EE" stroke-width="0.5">
      <line x1="0" y1={H * 0.2} x2={W} y2={H * 0.2} />
      <line x1="0" y1={H * 0.4} x2={W} y2={H * 0.4} />
      <line x1="0" y1={H * 0.6} x2={W} y2={H * 0.6} />
      <line x1="0" y1={H * 0.8} x2={W} y2={H * 0.8} />
    </g>

    <path d={areaD} fill="url(#area-grad)" />
    <path d={pathD} fill="none" stroke="#7B4FBE" stroke-width="2" />
  </svg>

  {#if footLeft || footRight}
    <div class="flex items-center justify-between mt-2.5 pt-2.5 border-t border-[var(--color-border-3)] text-[11px] text-[var(--color-text-muted)]">
      {#if footLeft}<div class="flex items-center gap-2"><span class="inline-block h-2 w-2 rounded-full" style="background: var(--color-pu)"></span> {footLeft}</div>{/if}
      {#if footRight}<div class="ml-auto">{footRight}</div>{/if}
    </div>
  {/if}
</div>
